import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import styled from "styled-components";
import moment from "moment";
import { StyledLabel } from "../../../components/styles";
import {
    SeparateLine,
    PageTitle,
    Tags,
    TagsContainer,
    WorkingConditionSteps,
    ProjectCondition,
    ButtonRow,
    DataView,
    StyledAction,
    ProjectFinancialLegalContainer,
    ObjectionContainer,
    ProjectInfo,
    ConditionSteps,
    ActionsContainer,
    DeactivateReasonContainer,
} from "../../../styles/elements/main";
import {
    FormGroup,
    FormRow,
    HintMessageContent,
    FormGroupTextEditor,
    RowFormGroupContainer,
} from "../../../styles/forms/main";
import {
    getConditionById,
    getObjectionById,
    getStandardsAndProceduresList,
    updateProjectInfo,
} from "../api";
import { mapConditionToUi, mapObjectionsToUi, mapOptionsToUi } from "./../mapToUi";
import Button from "./../../../components/button";
import { setMessage } from "./../../shared/notification/slice";
import Action from "../../../components/dropdownAction";
import AccordionComponent from "./../../../components/accordion";
import ObjectionsView from "./objectionsView";
import TabList from "./../../../components/tabList";
import QADetails from "./QADetails";
import ProjectFinancialLegalForm from "./ProjectFinancialLegal";
import { showLoader } from "../../shared/FullPageLoader/slice";
import { mapUpdateOperationsProjectInfoToData } from "../mapToData";
import ModalComponent from "../../../components/modal";
import Spinner from "../../../components/Spinner";
import TextArea from "../../../components/textArea";
import { getUserRoles } from "../../auth/slice";
import trackAnalytics from "../../../trackAnalytics";
import { compareObjects } from "../../../hooks/compareObjects";
import { mapUpdateProjectInfoToMixPanel } from "../mapDataToMixpanel";
import ExtraOperationalRequirements from "./ExtraOperationalRequirements";

export const ObjectionsContainer = styled.div`
    padding-bottom: 4rem;
`;

function OperationsProfile({
    projectId,
    clientProject,
    organizationId,
    penaltiesAndDeductions,
    setPenaltiesAndDeductions,
    setAllIllaDeductions,
    setAllClientDeductions,
    allIllaDeductions,
    allClientDeductions,
}) {
    const [activeWorkingCondition, setActiveWorkingCondition] = useState(0);
    const [ConditionData, setConditionData] = useState([]);
    const [objection, setObjection] = useState({});
    const dispatch = useDispatch();
    const history = useHistory();
    const [activeObjection, setActiveObjection] = useState("");
    const [SubmitObjectSuccess, setSubmitObjectSuccess] = useState(false);
    const [isProjectInfoEditable, setIsProjectInfoEditable] = useState(false);
    const [showDiscardEditModal, setShowDiscardModal] = useState(false);
    // QA details sections
    const [qaDetails, setQaDetails] = useState({});
    const [standardsAndProceduresList, setStandardsAndProceduresList] = useState([]);
    // Project Financial section
    const [projectFinancialLegal, setProjectFinancialLegal] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const getCurrentUserRoles = useSelector(getUserRoles());

    useEffect(() => {
        setQaDetails(clientProject?.qaDetails);
        setProjectFinancialLegal(clientProject?.projectFinancialLegal);
        fetchStandardsAndProcedures();
        setPenaltiesAndDeductions(clientProject?.deductionsValues);
    }, [clientProject]);

    useEffect(() => {
        if (clientProject) {
            if (!clientProject?.qaDetails?.operationsSiteVisitDetails) {
                setIsProjectInfoEditable(true);
            }
        }
    }, [clientProject]);

    useEffect(() => {
        SubmitObjectSuccess && getObjection(activeObjection);
        setSubmitObjectSuccess(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SubmitObjectSuccess]);

    useEffect(() => {
        if (clientProject?.salesConditionsId?.length > 0) {
            FetchProjectProfileCondition(clientProject?.salesConditionsId[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientProject]);

    useEffect(() => {
        if (ConditionData && ConditionData?.objectionsId?.length > 0)
            getObjection(ConditionData?.objectionsId[0]?.id);
    }, [ConditionData]);

    const fetchStandardsAndProcedures = async () => {
        const data = await getStandardsAndProceduresList();
        setStandardsAndProceduresList(
            mapOptionsToUi(
                _.values(data?.entities["standardsAndOperationalProcedures"]),
                "id",
                "description"
            )
        );
    };

    const FetchProjectProfileCondition = async (conditionId) => {
        const data = await getConditionById(conditionId);
        setConditionData(
            mapConditionToUi(
                _.values(data?.entities["monthlyProjectTruckTypeConditions"]),
                _.values(data?.entities["truckTypes"]),
                _.values(data?.entities["branches"]),
                _.values(data?.entities["suppliers"]),
                _.values(data?.entities["objections"])
            )
        );
        if (_.values(data?.entities["objections"]).length > 0) {
            const objectLength = Object.keys(_.values(data?.entities["objections"])).length;
            getObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
            setActiveObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
        }
    };

    const handleEditProjectInfo = () => {
        trackAnalytics("Edit Project info clicks");
        setIsProjectInfoEditable(true);
    };

    const handleSubmitProjectInfo = () => {
        setIsLoading(true);
        updateProject();
    };

    const updateProject = () => {
        const data = {
            qaDetails,
        };
        const changedProps = compareObjects(clientProject, { ...clientProject, ...data });
        const formData = mapUpdateOperationsProjectInfoToData(projectId, data);
        const mixPanelData = mapUpdateProjectInfoToMixPanel(
            changedProps,
            projectId,
            clientProject?.status
        );
        updateProjectInfo(projectId, formData)
            .then(() => {
                setIsLoading(false);
                dispatch(
                    setMessage({
                        content: `project profile condition updated successfully `,
                        isError: false,
                    })
                );
                history.push({
                    pathname: `/clientProjects/${projectId}`,
                    state: { clientId: organizationId, entityName: "projects" },
                });
                dispatch(showLoader());
                window.location.reload(false);
                if (!clientProject?.qaDetails?.operationsSiteVisitDetails) {
                    // case of first time submit
                    trackAnalytics(`Submit new project info  -  operations `, mixPanelData);
                } else {
                    trackAnalytics(`Save project info edits submissions`, mixPanelData);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                dispatch(
                    setMessage({
                        content: err,
                        title: `Couldn't update project profile info  `,
                        isError: true,
                    })
                );
            });
    };

    const handleOnClick = (item) => {
        getObjection(item?.id);
        setActiveObjection(item?.id);
    };
    const objectionBody = () => (
        <ObjectionContainer>
            <TabList
                list={ConditionData?.objectionsId}
                handleOnClick={handleOnClick}
            />
            <ObjectionsView
                objection={objection}
                activeObjectionId={activeObjection}
                projectId={projectId}
                submitObjectionSuccessfully={(value) => setSubmitObjectSuccess(value)}
            />
        </ObjectionContainer>
    );
    const getObjection = async (objectionId) => {
        const data = await getObjectionById(objectionId);
        setObjection(
            mapObjectionsToUi(
                _.values(data?.entities["creators"]),
                _.values(data?.entities["mentionedAdminUsers"]),
                _.values(data?.entities["adminUsers"]),
                _.values(data?.entities["items"]),
                _.values(data?.entities["sections"]),
                _.values(data?.entities["comments"]),
                _.values(data?.entities["objections"])
            )
        );
    };

    return (
        <>
            <ObjectionsContainer>
                <ProjectInfo>
                    <PageTitle>
                        <FormattedMessage id="client.project-create-header" /> #{projectId}
                        <TagsContainer>
                            <Tags>{clientProject?.status}</Tags>
                        </TagsContainer>
                    </PageTitle>
                    {!isProjectInfoEditable && (
                        <StyledAction>
                            <Action
                                options={[
                                    {
                                        name: "edit",
                                        eventHandler: () => handleEditProjectInfo(),
                                        disable: false,
                                    },
                                ]}
                                icon="<MoreVertIcon/>"
                            />
                        </StyledAction>
                    )}
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Client Name</StyledLabel>
                            <DataView>{clientProject?.clientName}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <StyledLabel>Project Name</StyledLabel>
                            <DataView>{clientProject?.name}</DataView>
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Project Type</StyledLabel>
                            <DataView>{clientProject?.projectType}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <StyledLabel>Requested Date </StyledLabel>
                            <DataView>{clientProject?.requestedAt}</DataView>
                        </FormGroup>
                    </FormRow>
                    <ProjectFinancialLegalContainer>
                        <ProjectFinancialLegalForm
                            projectFinancialLegal={projectFinancialLegal}
                            isEditable={false}
                            userRole="operations_specialist"
                            setAllIllaDeductions={setAllIllaDeductions}
                            setAllClientDeductions={setAllClientDeductions}
                            allIllaDeductions={allIllaDeductions}
                            allClientDeductions={allClientDeductions}
                            deductionsValues={penaltiesAndDeductions}
                            setDeductionsValues={setPenaltiesAndDeductions}
                        />
                    </ProjectFinancialLegalContainer>
                    <div>
                        <QADetails
                            isEditable={isProjectInfoEditable}
                            attachements={clientProject?.qaDetails?.attachments}
                            qADetails={qaDetails}
                            setQaDetails={(fieldName, value) => {
                                setQaDetails({
                                    ...qaDetails,
                                    [fieldName]: value,
                                });
                            }}
                            userRole="operations_specialist"
                            standardsAndProceduresList={standardsAndProceduresList}
                        />
                        <SeparateLine />
                    </div>
                    {isProjectInfoEditable && (
                        <ButtonRow>
                            <Button
                                type="button"
                                name="Cancel"
                                btnStyle="secondBtn"
                                onChange={() => setShowDiscardModal(true)}
                            />
                            <Button
                                type="button"
                                name={isLoading ? <Spinner /> : "Save"}
                                btnStyle="primaryBtn"
                                onChange={handleSubmitProjectInfo}
                            />
                        </ButtonRow>
                    )}
                    <ModalComponent
                        header="Discard edits"
                        open={showDiscardEditModal}
                        onClose={() => {
                            setShowDiscardModal(false);
                        }}
                        submitBtnText="Discard"
                        onSubmit={() => {
                            trackAnalytics(`${getCurrentUserRoles}_project_cancel_editing`);
                            setProjectFinancialLegal(clientProject?.projectFinancialLegal);
                            setQaDetails(clientProject?.qaDetails);
                            setShowDiscardModal(false);
                            setIsProjectInfoEditable(false);
                        }}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        If you discard it now, you'll lose all the edits you've made
                    </ModalComponent>
                </ProjectInfo>
                <div>
                    <WorkingConditionSteps>
                        {clientProject?.salesConditionsId?.map((item, index) => (
                            <ConditionSteps
                                key={index}
                                className={index === activeWorkingCondition ? "active" : ""}
                                onClick={() => {
                                    setActiveWorkingCondition(index);
                                    FetchProjectProfileCondition(item);
                                    ConditionData?.objectionsId?.length > 0 &&
                                        getObjection(ConditionData?.objectionsId[0]?.id);
                                }}
                            >
                                Working condition {index + 1}
                            </ConditionSteps>
                        ))}
                    </WorkingConditionSteps>
                    <ProjectCondition>
                        <div>
                            <ActionsContainer>
                                {ConditionData?.status && <Tags>{ConditionData?.status}</Tags>}
                            </ActionsContainer>
                            {ConditionData?.salesData?.deactivationReason !== null &&
                                ConditionData?.status?.toLowerCase() === "deactivated" && (
                                    <DeactivateReasonContainer>
                                        <WarningAmberIcon />
                                        <HintMessageContent>
                                            <h3>This Condition Deactivated</h3>
                                            <p>{ConditionData?.salesData?.deactivationReason}</p>
                                        </HintMessageContent>
                                    </DeactivateReasonContainer>
                                )}
                            {ConditionData.declinationDetails !== null &&
                                ConditionData?.status?.toLowerCase() === "declined" && (
                                    <DeactivateReasonContainer>
                                        <WarningAmberIcon />
                                        <HintMessageContent>
                                            <h3>This Condition has been declined</h3>
                                            {ConditionData?.declinationDetails?.salesPricing !==
                                                null && (
                                                <div className="decline-item">
                                                    <label>- sales Pricing</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.salesPricing
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                            {ConditionData?.declinationDetails?.supplierPricing !==
                                                null && (
                                                <div className="decline-item">
                                                    <label>- supply Pricing</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.supplierPricing
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                            {ConditionData?.declinationDetails?.supplierFulfillment !==
                                                null && (
                                                <div className="decline-item">
                                                    <label>- supply Fulfilment</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.supplierFulfillment
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                            {ConditionData?.declinationDetails
                                                ?.clientRequirements !== null && (
                                                <div className="decline-item">
                                                    <label>- client Requirement</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.clientRequirements
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                        </HintMessageContent>
                                    </DeactivateReasonContainer>
                                )}
                            <h3>Truck Details</h3>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Truck Type</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.truckTypeName}</DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Number of Trucks</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.numberOfTrucks}</DataView>
                                </FormGroup>
                            </FormRow>
                            {ConditionData?.salesData?.hasPreferredModelYear && (
                                <FormRow>
                                    <FormGroup>
                                        <StyledLabel>Required model year starts from</StyledLabel>
                                        <DataView>
                                            {ConditionData?.salesData?.requiredModelYearStartsFrom}
                                        </DataView>
                                    </FormGroup>
                                </FormRow>
                            )}
                        </div>
                        <SeparateLine />
                        <ExtraOperationalRequirements
                            isEditable={false}
                            workingCondition={ConditionData?.salesData}
                        />
                        <div>
                            <h3>Client Operational Details</h3>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Kick-off Date</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.kickoffDate}</DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>End Date</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.endDate}</DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Maximum number of drop-offs</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.maximumNumberOfDropOff}
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Operational Model</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.salesChannels &&
                                            Array.from(
                                                ConditionData?.salesData?.salesChannels
                                            )?.map((model) => (
                                                <span key={model}>{model.value}</span>
                                            ))}
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Working Area</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.serviceAreas &&
                                            Array.from(ConditionData?.salesData?.serviceAreas)?.map(
                                                (area) => <span key={area}>{area.value}</span>
                                            )}
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Pickup Location</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.pickUpLocation}</DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Pickup Arrival Time</StyledLabel>
                                    <DataView>
                                        {moment(ConditionData?.salesData?.pickUpTime).format("LT")}
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Number of Working Days per Month</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.workingDaysPerMonth}
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Weekly Off Days</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.weeklyOffDays.map((day) => (
                                            <span key={day}>{day.value}</span>
                                        ))}
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel> Working Hours per Day</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.workingHoursPerDay}
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Mileage</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.kiloMeters}</DataView>
                                </FormGroup>
                            </FormRow>
                            {ConditionData?.salesData?.operationalSpecialDetails && (
                                <FormRow>
                                    <FormGroupTextEditor>
                                        <StyledLabel>
                                            {" "}
                                            Special Requirements for Operational
                                        </StyledLabel>
                                        <DataView>
                                            {ConditionData?.salesData?.operationalSpecialDetails}
                                        </DataView>
                                    </FormGroupTextEditor>
                                </FormRow>
                            )}
                        </div>
                        <SeparateLine />
                        <div>
                            <h3>Supply Fulfillment Details </h3>
                            {ConditionData?.supplyData?.fullFillmentDetails?.suppliers.map(
                                (supplier) => (
                                    <>
                                        <FormRow>
                                            <FormGroup>
                                                <StyledLabel>Suppliers</StyledLabel>
                                                <DataView>{supplier?.supplier}</DataView>
                                            </FormGroup>
                                            <FormGroup>
                                                <StyledLabel>Number of Trucks</StyledLabel>
                                                <DataView>{supplier?.numberOfTrucks}</DataView>
                                            </FormGroup>
                                        </FormRow>
                                        {supplier?.assignedTrucks.length > 0 &&
                                            supplier?.assignedTrucks.map((truck, index) => (
                                                <FormRow key={index}>
                                                    <RowFormGroupContainer>
                                                        <FormGroup>
                                                            <StyledLabel>
                                                                {`Truck ${index + 1}`}
                                                            </StyledLabel>
                                                            <DataView>{truck.truck}</DataView>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <StyledLabel>
                                                                {`Driver ${index + 1}`}
                                                            </StyledLabel>
                                                            <DataView>{truck.driver}</DataView>
                                                        </FormGroup>
                                                    </RowFormGroupContainer>
                                                </FormRow>
                                            ))}
                                        <FormRow>
                                            <FormGroup>
                                                <StyledLabel>Working Hours per Day</StyledLabel>
                                                <DataView>{supplier?.workingHoursPerDay}</DataView>
                                            </FormGroup>
                                            <FormGroup>
                                                <StyledLabel>Mileage</StyledLabel>
                                                <DataView>{supplier?.kiloMeters}</DataView>
                                            </FormGroup>
                                        </FormRow>
                                    </>
                                )
                            )}
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Number of Helpers</StyledLabel>
                                    <DataView>
                                        {
                                            ConditionData?.supplyData?.fullFillmentDetails
                                                ?.numberOfHelpers
                                        }
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Number of delivery Delegates</StyledLabel>
                                    <DataView>
                                        {
                                            ConditionData?.supplyData?.fullFillmentDetails
                                                ?.deliveryDelegate
                                        }
                                    </DataView>
                                </FormGroup>
                            </FormRow>

                            {ConditionData?.supplyData?.supplierOtherDetails && (
                                <FormRow>
                                    <FormGroupTextEditor>
                                        <StyledLabel>Supplier Other Details </StyledLabel>
                                        <DataView>
                                            {ConditionData?.supplyData?.supplierOtherDetails}
                                        </DataView>
                                    </FormGroupTextEditor>
                                </FormRow>
                            )}
                        </div>
                        <SeparateLine />
                        <div>
                            <h3>Pricing Details</h3>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Truck price per month*</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.truckPricePerMonth
                                                ) >
                                                Number(ConditionData?.salesData?.truckPricePerMonth)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales: </h4>
                                            {ConditionData?.salesData?.truckPricePerMonth}
                                        </span>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.truckPricePerMonth
                                                ) >
                                                Number(ConditionData?.salesData?.truckPricePerMonth)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.truckPricePerMonth
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Fuel Price per Kilometer</StyledLabel>
                                    <DataView>
                                        <span>
                                            {ConditionData?.salesData?.fuelPricePerKilometer}
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Oil Price per Kilometer</StyledLabel>
                                    <DataView>
                                        <span>
                                            {ConditionData?.salesData?.oilPricePerKilometer}
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Truck daily price</StyledLabel>
                                    <DataView>
                                        <span>{ConditionData?.salesData?.truckDailyPrice}</span>
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Extra Working Hour Price</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraHourPrice
                                                ) > Number(ConditionData?.salesData?.extraHourPrice)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>{" "}
                                            {ConditionData?.salesData?.extraHourPrice}
                                        </span>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraHourPrice
                                                ) > Number(ConditionData?.salesData?.extraHourPrice)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>

                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraHourPrice
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Extra Kilometer Price*</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraUnitDistancePrice
                                                ) >
                                                Number(
                                                    ConditionData?.salesData?.extraUnitDistancePrice
                                                )
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>
                                            {ConditionData?.salesData?.extraUnitDistancePrice}
                                        </span>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraUnitDistancePrice
                                                ) >
                                                Number(
                                                    ConditionData?.salesData?.extraUnitDistancePrice
                                                )
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraUnitDistancePrice
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Over Night Stay Price</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.overnightPrice >
                                                ConditionData?.salesData?.overnightPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>{" "}
                                            {ConditionData?.salesData?.overnightPrice} %
                                        </span>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.overnightPrice >
                                                ConditionData?.salesData?.overnightPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.overnightPrice
                                            }{" "}
                                            %
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Extra Day Price*</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraDayPrice >
                                                ConditionData?.salesData?.extraDayPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>{" "}
                                            {ConditionData?.salesData?.extraDayPrice}
                                        </span>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraDayPrice >
                                                ConditionData?.salesData?.extraDayPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraDayPrice
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                        </div>
                    </ProjectCondition>
                </div>
            </ObjectionsContainer>
            {ConditionData && ConditionData?.objectionsId?.length > 0 && (
                <div>
                    <AccordionComponent
                        id="Objection"
                        title="objections"
                        body={objectionBody()}
                        defaultExpanded
                    />
                </div>
            )}
        </>
    );
}

export default OperationsProfile;
